<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">MY PAGE</p>
        <p>전남드래곤즈 회원을 위한 마이페이지입니다.</p>
      </li>
    </ul>

    <div class="menu-list">
      <div v-for="(menu, index) in menuList" :key="index" class="item">
        <router-link :to="{name: menu.name}">
          <div class="img-div">
            <img :src="imageSrc(menu.img)" alt="menu">
          </div>
          <p>{{menu.menuNm}}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPage',
  data() {
    return {
      menuList: [
        {
          menuNm: '회원정보수정',
          name: 'myInfo',
          img: 'myinfo'
        // }, {
        //   menuNm: '1:1 문의게시판',
        //   name: 'contactUs',
        //   img: 'contactus'
        }, {
          menuNm: '회원탈퇴',
          name: 'withdraw',
          img: 'withdraw'
        }
      ],
    }
  },
  mounted () {
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/icon/icon_'+imgSrc+'.png');
    }
  }
}
</script>
